import { useForm } from "react-hook-form";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { FormSwitchInput } from "../../../../../../common/components/masked_inputs/react_forms/form_switch_input";
import { initialChecklistMaquinaEquipForm } from "../../../schemas/ChecklistMaquinaEquip_lista/checklist_maquina_equip";

import FormContainer from "../../../../../../common/components/form_container";
import { PatrimonioCentroCustoModel } from "../../../../domain/models/patrimonio_centro_custo";
import { PatrimonioCentroCustoForm, PatrimonioCentroCustoSchema } from "../../../schemas/PatrimonioMaquinaEquip/patrimonio_centro_custo";
import { DropDownCentroCusto } from "../../../../../../common/components/dropdown_centro_custo";

/**
 * ChecklistMaquinaEquipModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  selectedPatrimonioCentroCusto: PatrimonioCentroCustoModel | null;
  onClose: (idChecklistMaquinaEquip: number | null, openState: boolean) => void;
  onSubmit: (form: PatrimonioCentroCustoForm) => void;
};

export const PatrimonioCentroCustoModal = ({
  open,
  saving,
  loading,
  selectedPatrimonioCentroCusto,
  onClose,
  onSubmit,
}: Props) => {
  const hookForm = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(PatrimonioCentroCustoSchema),
  });

  useEffect(() => {
    if (open) {
      if (selectedPatrimonioCentroCusto) {
        hookForm.setValue('status', selectedPatrimonioCentroCusto.status ?? 0);
        hookForm.setValue('idCentroCusto', selectedPatrimonioCentroCusto.idCentroCusto);
        hookForm.setValue('idPatrimonioCentroCusto', selectedPatrimonioCentroCusto.idPatrimonioCentroCusto ?? 0);
      } else {
        hookForm.reset({
          ...initialChecklistMaquinaEquipForm,
          status: 0,
        });
      }
    }
  }, [
    open,
    selectedPatrimonioCentroCusto,
    hookForm,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      width="50rem"
      title='Centro de Custo maquina/Equipamento'
      onClose={() => onClose(null, false)}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <div className="w-full flex flex-col">
        <FormContainer title='Informações' arrangement='fullRow' paddingTop="small" paddingBottom="normal" gap='small' border={false}>
          <>

            <FormSwitchInput
              name='status'
              activeLabel="Finalizado"
              inactiveLabel="Em Andamento"
              readOnly={saving}
              reactHookForm={hookForm}
            />

            <DropDownCentroCusto
              name='idCentroCusto'
              label='Centro de Custo'
              required={true}
              readOnly={saving}
              reactHookForm={hookForm}
            />

          </>
        </FormContainer>
      </div>
    </BaseFormControlledModal >
  );
}